import styles from '../CommonCss/OrderEngineCommon.module.css'
import ModalWindow from "../../../FormTemplate/ModalWindow/ModalWindow";
import MainFormTemplate from "../../../FormTemplate/MainFormTemplate/MainFormTemplate";
import InputItem from "../../../FormTemplate/InputItem/InputItem";
import ErrorLineItem, {ErrorLineItemRef} from "../../../FormTemplate/ErrorLineItem/ErrorLineItem";
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../../ApiQuery/UseApiQuery";
import WaitLoader from "../../../WaitLoader/WaitLoader";
import SelectUnit, {SelectUnitDataInt, SelectUnitRefInt} from "../../../FormTemplate/SelectUnit/SelectUnit";


interface UpdateOrderInt
{
    orderId:string
    customerId:number
}

interface OrderEngineChangeDeliveryInt
{
    orderId:string
    onClose: ()=>void
    onSuccess?: ()=>void


}

export default function OrderEngineChangeDelivery({orderId,onClose,onSuccess}:OrderEngineChangeDeliveryInt){

    const orderUpdateData = useRef<UpdateOrderInt>()
    const [ldrOrderUpdate,rsOrderUpdate,exOrderUpdate] = useApiQuery("/sell/sim/order/delivery/change","post",orderUpdateData);


    const updateDelivery = useRef<ErrorLineItemRef>(null)

    const [valid, setValid] = useState(false)
    const [useAsDelivery, setUseAsDelivery] = useState(true)

    const deliveryList = useRef()
    const [ldrDelivery,rsDelivery,exDelivery] = useApiQuery("/ref/delivery/list","get",deliveryList);
    const [deliveryListData, setDeliveryListData] = useState<SelectUnitDataInt[]>([])
    const [customerId, setCustomerId] = useState(-1)


    const deliveryListRef =useRef<SelectUnitRefInt>(null)

    useEffect(()=>{
        loadDeliveryList()
    },[deliveryList])

    const loadDeliveryList = () =>{
        exDelivery().then((e)=>{
            if(e?.success )
            {
                const aData = (e?.payload?.map((item:any)=>{
                    return {
                        name: item?.name + ` [ ${item?.customerId} ]`,
                        val: item?.customerId

                    }
                }))
                setDeliveryListData(aData)
                return
            }
            if(updateDelivery.current )updateDelivery.current?.show(e?.errorAsString,true,0)
        })
    }

    const handleUpdateDelivery = () =>{
        if(customerId < 0 ){
            if(updateDelivery?.current)updateDelivery?.current?.show("Не выбран оператор доставки", true,3000)
            return
        }
        orderUpdateData.current = {
            orderId: orderId,
            customerId: customerId
        }
        exOrderUpdate().then((e)=>{
            if(e?.success)
            {
                if(updateDelivery.current)updateDelivery.current.show(`Оператор доставки в заказа ${orderId} обновлен`,false,0)
                if(onSuccess) onSuccess()
                return
            }
            if(updateDelivery.current)updateDelivery.current.show(e?.errorAsString ? e?.errorAsString :"Ошибка сервера",true,3000)
        })

    }


    return(
        <ModalWindow cssClass={styles.noOver} >
            <MainFormTemplate title={`Оператор доставки заказ [${orderId}]`} maxWidth={"450px"} background={"white"}>
                <div className={"row"}>
                    <div className={"col-lg-12"}>
                        <div className={styles.suCont}>
                            <SelectUnit ref={deliveryListRef} inData={deliveryListData} capt={"Доставка"} multiSelect={false} getVal={(e)=>{
                                //if(e.length   === 0) return
                                if(e?.length) setCustomerId(Number(e[0]))


                            }}/>
                        </div>
                    </div>
                </div>
                <ErrorLineItem ref={updateDelivery} ></ErrorLineItem>

                <div className={styles.actCont}>
                    <div className={styles.btnCont}>
                        <button type="button" className="btn btn-secondary "
                                disabled={customerId < 0}
                                onClick={(e)=>{
                                    handleUpdateDelivery()
                                }}
                        >Обновить</button>
                    </div>
                    <div className={styles.btnCont}>
                        <button type="button" className="btn btn-secondary "
                                onClick={(e)=>{
                                    onClose()
                                }}
                        >Закрыть</button>
                    </div>
                    <WaitLoader loading={ldrOrderUpdate } api={rsOrderUpdate} onlyLoading={true}>

                    </WaitLoader>

                </div>

            </MainFormTemplate>
        </ModalWindow>
    )
}